<template>
  <v-card>
    <!-- <v-card-title>User Login</v-card-title> -->
    <v-list>
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon x-large>person_add</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>Create New Account</v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-btn icon fav small outline @click="onCancelled">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <v-card-text style="max-height: 85%;">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout column>
          <v-subheader class="headline ma-0">Personal information</v-subheader>
          <v-flex xs12>
            <v-text-field
              outline
              label="Full Name *"
              required
              v-model="signUp.first_name"
              :rules="requiredRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field outline label="Mobile No *" v-model="signUp.phone" :rules="requiredRules"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              type="email"
              outline
              label="Email Address"
              v-model="signUp.email"
              :rules="emailRules"
            ></v-text-field>
          </v-flex>
          <v-textarea v-model="signUp.address" outline label="Address *" :rules="requiredRules"></v-textarea>
          <v-subheader class="headline ma-0">Login information</v-subheader>
          <v-flex xs12>
            <v-text-field
              type="Password"
              outline
              label="Password"
              v-model="signUp.password"
              :rules="[...requiredRules, ...passwordLengthRules]"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              type="Password"
              outline
              label="Re-password"
              v-model="signUp.re_password"
              :rules="[...requiredRules, ...rePasswordRules]"
            ></v-text-field>
          </v-flex>
          <v-flex text-xs-right>By creating account I agree to the terms & condition.</v-flex>
        </v-layout>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn color="blue" @click="clearForm">Clear</v-btn>
      <v-spacer></v-spacer>
      <v-btn
        color="blue"
        @click="signUpDo"
        :disabled="!valid || actionButtonClicked"
        :loading="actionButtonClicked"
      >Sign Up</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      actionButtonClicked : false,
      valid: true,
      signUp: {
        first_name: "",
        phone: "",
        email: "",
        address: "",
        password: "",
        re_password: ""
      },
      rePasswordRules: [
        v => this.signUp.password == v || "Password did not matched."
      ]
    };
  },
  methods: {
    onCancelled() {
      this.$emit("cancelled");
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    clearForm() {
      this.signUp = {
        first_name: "",
        phone: "",
        email: "",
        address: "",
        password: "",
        re_password: ""
      };
    },
    signUpDo() {
      if (this.$refs.form.validate()) {
        this.actionButtonClicked = true;
        this.post("/signup", this.signUp).then(res => {
          if (res.data.success) {
            this.$emit("cancelled", true);
            this.clearForm();
          }
          this.snackbarShow(res.data);
          this.actionButtonClicked = false;
        });
      }
    }
  }
};
</script>